import {
  RESET_STATUS_TENDER,
  SUCCESS_GET_STATUS_TENDER,
} from "../../constants/tendering/proposalTenderTypes";

const initState = {};

const tenderStatusReducer = (state = initState, action) => {
  switch (action.type) {
    case SUCCESS_GET_STATUS_TENDER:
      return { ...state, [action.data.uuid]: action.data };
    case RESET_STATUS_TENDER:
      return {};
    default:
      return state;
  }
};

export default tenderStatusReducer;
